/** Spec 036: the Manual trade pair dropdown's search and grouping (pure). */

export interface PairLike {
  symbol: string
  description: string
  group: string
}

/** Case-insensitive substring match on symbol or description; blank query = everything. Order preserved. */
export function filterSymbols<T extends PairLike>(symbols: T[], query: string): T[] {
  const q = query.trim().toUpperCase()
  if (q === '') return symbols
  return symbols.filter((s) => s.symbol.toUpperCase().includes(q) || s.description.toUpperCase().includes(q))
}

export interface SymbolGroup<T> {
  group: string
  items: T[]
}

/** Groups in first-seen order (so a `Metals / Forex / Crypto` list keeps that order). */
export function groupSymbols<T extends PairLike>(symbols: T[]): SymbolGroup<T>[] {
  const groups: SymbolGroup<T>[] = []
  for (const s of symbols) {
    let g = groups.find((x) => x.group === s.group)
    if (!g) {
      g = { group: s.group, items: [] }
      groups.push(g)
    }
    g.items.push(s)
  }
  return groups
}
